import $ from 'jquery'

$(document).ready(function() {
    $('.auth-page-wrapper').height($(window).height())
})